import React, { PureComponent } from 'react';

import { CompanyCodeDetailsPropTypes } from '../../shared/propTypes/companyCodes';

class CompanyCodeSettings extends PureComponent {
  static propTypes = {
    companyCodeDetails: CompanyCodeDetailsPropTypes.isRequired,
  };

  render() {
    const {
      companyCode,
      legalEntity,
      businessUnit,
      associatedLeGoldId,
      associatedLeCountryCode,
      associatedLeUsTaxType,
      associatedLeLocalTaxType,
      connName,
      chartName,
      functionalCurrency,
      statCurrency,
      overrideTaxCurrency,
      usShareholderFlag,
      associatedLeBranch,
      homeOfficeCompanyCode,
      homeOfficeCountryCode,
      recordHomeOfficeTaxes,
      recordFTC,
      ledgerId,
      subledgerFlag,
      statCalc,
    } = this.props.companyCodeDetails;

    return (
      <div className="company-code-settings container-fluid">
        <div className="row content">
          <div className="col-12 col-sm-6">
            <div className="row">
              <div className="col-6 value">Company Code</div>
              <div className="col-6 value">{companyCode}</div>
              <div className="col-6 value">Legal Entity</div>
              <div className="col-6 value">{legalEntity}</div>
              <div className="col-6 value">Business Unit</div>
              <div className="col-6 value">{businessUnit}</div>
              <div className="col-6 value">GOLD ID</div>
              <div className="col-6 value">{associatedLeGoldId}</div>
              <div className="col-6 value">Country of Domicile</div>
              <div className="col-6 value">{associatedLeCountryCode}</div>
              <div className="col-6 value">US Tax Type</div>
              <div className="col-6 value">{associatedLeUsTaxType}</div>
              <div className="col-6 value">Local Tax Type</div>
              <div className="col-6 value">{associatedLeLocalTaxType}</div>
              <div className="col-6 value">Connection</div>
              <div className="col-6 value">{connName}</div>
              <div className="col-6 value">Chart</div>
              <div className="col-6 value">{chartName}</div>
              <div className="col-6 value">Functional Currency</div>
              <div className="col-6 value">{functionalCurrency}</div>
              <div className="col-6 value">STAT Currency</div>
              <div className="col-6 value">{statCurrency}</div>
            </div>
          </div>
          <div className="col-12 col-sm-6">
            <div className="row">
              <div className="col-6 value">Override Tax Currency</div>
              <div className="col-6 value">{overrideTaxCurrency}</div>
              <div className="col-6 value">US Shareholder Flag</div>
              <div className="col-6 value">{usShareholderFlag}</div>
              <div className="col-6 value">Branch</div>
              <div className="col-6 value">{associatedLeBranch}</div>
              <div className="col-6 value">Home Office Company Code</div>
              <div className="col-6 value">{homeOfficeCompanyCode}</div>
              <div className="col-6 value">Home Office Country Code</div>
              <div className="col-6 value">{homeOfficeCountryCode}</div>
              <div className="col-6 value">Record Home Office Taxes</div>
              <div className="col-6 value">{recordHomeOfficeTaxes}</div>
              <div className="col-6 value">Record FTC</div>
              <div className="col-6 value">{recordFTC}</div>
              <div className="col-6 value">Ledger ID</div>
              <div className="col-6 value">{ledgerId}</div>
              <div className="col-6 value">BSM Flag</div>
              <div className="col-6 value">{subledgerFlag}</div>
              <div className="col-6 value">STAT Calc Flag</div>
              <div className="col-6 value">{statCalc}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


export default CompanyCodeSettings;
